import { render, staticRenderFns } from "./DashboardModalPendenciasContratos.vue?vue&type=template&id=2e101c24"
import script from "./DashboardModalPendenciasContratos.vue?vue&type=script&lang=js"
export * from "./DashboardModalPendenciasContratos.vue?vue&type=script&lang=js"
import style0 from "./DashboardModalPendenciasContratos.vue?vue&type=style&index=0&id=2e101c24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports